/**
 * filter
 *
 * @author Shigq
 * @date 2021/11/9 15:23
 */
var dataUtils = require('./date-utils')
var currencyUtils = require('./currency-utils')

/**
 * date
 *
 * @param value
 * @param formatString
 * @returns {string}
 */
function date(value, formatString) {
	return dataUtils.formatDate(value, formatString)
}

/**
 * currency & rate
 *
 * @param value
 * @param cur
 * @param number
 * @param type
 * @returns {string}
 */
function currency(value, cur, number, type) {
	number = number || '2';
	//JPY特殊处理
	if (cur == 'JPY' && type == 'rate') {
		number = '2';
	} else if (cur == 'JPY' && type == 'amount') {
		number = '0';
	} else if (type == 'rate') {
		number = '4';
	} else if (type == 'amount') {
		number = '2';
	} else {
		number = number || '2';
	}
	return currencyUtils.formatMoney(value, number, '');
}


module.exports = {
	date,
	currency
}
